<script lang="ts">
  export interface GlobalSearchContextItemProps {
    context: SearchContextType
  }
</script>

<script setup lang="ts">
  import type { SearchContextType } from '../../utils/global-search-utils'
  import { searchContextTypesMapping } from '../../utils/global-search-utils'
  import { useSearch } from '../../utils/search-providers'

  const props = defineProps<GlobalSearchContextItemProps>()

  const { searchInputValue, isSearchInputEmpty } = useSearch()
</script>
<template>
  <div class="flex w-full items-center gap-2 px-4 py-2" v-if="context">
    <gat-icon icon="Search" class="size-4" />
    <template v-if="!isSearchInputEmpty">
      Search for "{{ searchInputValue }}" in
    </template>
    <template v-else> Search in </template>
    {{ searchContextTypesMapping[context].title }}
    <slot name="actions">
      <GatKeyboardShortcuts
        class="ml-auto"
        :shortcut="`${searchContextTypesMapping[context].prefix}:`"
      />
    </slot>
  </div>
</template>
